// Where "Open on Instagram" goes on a post's results. A mock provider (PUBLISH_MODE=mock on
// preview) hands back made-up permalinks on .local hosts that no browser can reach; those posts
// were simulated, and the page says so instead of offering a dead link.

export type ResultLink = { kind: 'link'; href: string } | { kind: 'simulated' } | null;

function isLocalHost(url: string): boolean {
  try {
    return new URL(url).hostname.endsWith('.local');
  } catch {
    return false;
  }
}

export function resultLink(
  permalink: string | null,
  providerMode: 'mock' | 'live' | null | undefined,
): ResultLink {
  if (providerMode === 'mock') return { kind: 'simulated' };
  if (!permalink) return null;
  if (isLocalHost(permalink)) return { kind: 'simulated' };
  return { kind: 'link', href: permalink };
}
